var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Chip",class:_vm.rootClasses,on:{"click":_vm.onClick}},[(_vm.icon)?_c('div',{staticClass:"Icon"},[_c(_vm.icon,{tag:"component"})],1):_vm._e(),_c('span',{staticClass:"Text"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }